export default (categoriesParam) => ({
  activeCategoryId: null,
  categories: categoriesParam,
  init() {
    const urlParam = new URLSearchParams(window.location.search);
    const activeParam = urlParam.get("coverage");
    if (activeParam) {
      this.activeCategoryId = this.categories.find(c => c.slug == activeParam)?.id;
    }
    if (!this.activeCategoryId) {
      this.activeCategoryId = this.categories[0].id;
    }
  },
  buttonClick(catId) {
    this.activeCategoryId = catId;
    this.$el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  },
  selectChange() {
    this.$el.closest('[x-data]').scrollIntoView({ behavior: 'smooth', block: 'start' });
  }
});
